//Install
import React, { Component } from "react";
//Install
import C814XM from "../../Media/Image/000.png";

//Element
class Brand extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB k771bl", href: "/" },
            //Element
            React.createElement("img", { alt: "Temas", title: "Temas", src: C814XM, width: "160", height: "auto" })
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Brand;